import { SearchSectionForm } from 'src/components/common/form/search/SearchSectionForm';
import { SearchInputForm } from 'src/components/common/form/search/SearchInputForm';
import useSYS2020_R01Store from './Store_SYS2020_R01';

interface Props {
	onEnterKeyDown: () => void;
}

export const SearchSection_SYS2020_R01 = ({ onEnterKeyDown }: Props) => {
	const { SYS2020_R01Filter, setSYS2020_R01Filter } = useSYS2020_R01Store();

	return (
		<SearchSectionForm>
			<SearchInputForm
				label="코드"
				value={SYS2020_R01Filter.commentCd}
				onChange={(e) => setSYS2020_R01Filter({ commentCd: e.target.value })}
				initValue={() => setSYS2020_R01Filter({ commentCd: '' })}
				onKeyDown={(e) => e.key === 'Enter' && onEnterKeyDown()}
			/>
			<SearchInputForm
				label="용도"
				value={SYS2020_R01Filter.description}
				onChange={(e) => setSYS2020_R01Filter({ description: e.target.value })}
				initValue={() => setSYS2020_R01Filter({ description: '' })}
				onKeyDown={(e) => e.key === 'Enter' && onEnterKeyDown()}
			/>
		</SearchSectionForm>
	);
};
